import { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DataGrid, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid';
import MasterMoreMenu from '../admin/MasterMoreMenu';
import { flastUpdatedDateTimeNew } from '../../utils/formatTime';
import Scrollbar from '../../components/scrollbar';
import CustomGridToolbar from '../../components/custom-gridtoolbar';
// ---------------------------------------------------------------------------------------------------------------

MasterDataGrid.propTypes = {
    columnData: PropTypes.array,
    rowData: PropTypes.array,
    masterName: PropTypes.string,
    lastUpdatedDate: PropTypes.string,
    loading: PropTypes.bool,
};
// ---------------------------------------------------------------------------------------------------------

export default function MasterDataGrid({ loading, columnData, rowData, masterName, lastUpdatedDate }) {

    const [pageSize, setPageSize] = useState(5);
    const [selectedForDelete, setSelectedForDelete] = useState();
    const [rowIndex, setRowIndex] = useState([]);
    const [filtervalue, setFilterValue] = useState('All');
    const [returnFilterValue, setReturnFilterValue] = useState('All');
    // const [lastUpdatedDate, setLastUpdatedDate] = useState(fDate(new Date()));

    const handelSelect = (e) => {
        setSelectedForDelete(e.length);
        setRowIndex(e);
    };
    const filters = useMemo(() => [
        { name: 'All' },
        { name: 'Pending' },
        { name: 'Dispatch' },
        { name: 'Received' }
    ], []); // Empty dependency array since filters does not depend on any props or state


    const returnFilter = useMemo(() => [
        { name: 'All' },
        { name: 'Delivered' },
        { name: 'In-Transit' },
    ], []);

    const handleFilterChange = useCallback((e) => {
        console.log('e', e);
        setFilterValue(e.target.value);
    }, []);

    // return
    const handleReturnFilterChange = useCallback((e) => {
        console.log('e', e);
        setReturnFilterValue(e.target.value);
    }, []);

    const CustomToolbar = useCallback(() =>
        <CustomGridToolbar
            rows={rowData}
            records={` Total No. of Records [${rowData.length}]`}
            lastUpdate={flastUpdatedDateTimeNew(lastUpdatedDate)}
            selectedForDelete={selectedForDelete}
            rowIndex={rowIndex}
            filterData={filters}
            returnFilterData={returnFilter}
            handleFilterChange={handleFilterChange}
            handleReturnFilterChange={handleReturnFilterChange}
            filterValue={filtervalue}
            returnFilterValue={returnFilterValue}
            columnData={columns}
        />, [rowData, lastUpdatedDate, selectedForDelete, rowIndex, filters, returnFilter, filtervalue, handleFilterChange, handleReturnFilterChange, returnFilterValue, columns]);

    const columns = useMemo(() => [
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            width: 20,
            renderCell: (cellValues) => (

                <MasterMoreMenu rowId={cellValues} masterName={masterName} columnData={columnData} rowData={rowData} />
            )
        },
        {
            ...GRID_CHECKBOX_SELECTION_COL_DEF,
            width: 20,
        },
        ...columnData,
    ], [columnData, masterName, rowData]);

    //  const rowData = [{ distributorCode: 123, distributorName: 'Ramesh', uploadType: 'Distributor' }]

    return (
        <Scrollbar>
            <DataGrid
                rows={rowData}
                columns={columns}
                getRowId={(row) => rowData.indexOf(row)}
                checkboxSelection
                onSelectionModelChange={e => handelSelect(e)}
                disableSelectionOnClick
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[100, 200, 300]}
                sx={{
                    '.MuiDataGrid-row': {
                        pl: 0
                    },
                    '.MuiDataGrid-columnHeader': {
                        pl: 1
                    },
                    '.MuiDataGrid-columnHeaderCheckbox': {
                        pl: 0
                    }
                }}
                components={{
                    Toolbar: CustomToolbar,
                }}
                //  rowHeight={30}
                //  headerHeight={35}
                density='compact'
                loading={loading}
            />
        </Scrollbar>
    );
}